import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import AdminAutoComplete from "../../NestedComponents/widgets/adminAutoComplete";
import AdminCoursesPopup from "../../NestedComponents/widgets/adminCoursesPopup";
import adminService from "../../Services/adminService";

const AdminAssignAllowedCourses = (props) => {
  const [newUserInfo, setNewUserInfo] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);
  const [allAllowedUsers, setAllAllowedUsers] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    async function getAllowedUsers() {
      const res = await adminService.getAllowedUsers();
      if (res.success) {
        setAllAllowedUsers(res.allUsers);
      }
    }
    getAllowedUsers();
  }, []);

  return (
    <div className="flex flex-direction-column items-center height500">
      <h3 className="mt-30 mb-50">הקצה קורסים מותרים למשתמש</h3>
      <AdminCoursesPopup
        isPopupOpen={isPopupOpen}
        popupTitle="הוסף פרטי משתמש חדש"
        buttonText="להוסיף"
        handleClosePopup={handleClosePopup}
        handleAction={handleAddAllowedUser}
      >
        <div className="flex flex-direction-column items-center">
          <TextField
            style={{ marginTop: "20px", width: "300px" }}
            label='דוא"ל משתמש'
            value={newUserInfo.email || ""}
            onChange={(e) => onAddUserChange("email", e.target.value)}
          />
          <TextField
            style={{ marginTop: "20px", width: "300px" }}
            label="סיסמת משתמש"
            value={newUserInfo.password || ""}
            onChange={(e) => onAddUserChange("password", e.target.value)}
          />
          <TextField
            style={{ marginTop: "20px", width: "300px" }}
            label="שם משתמש"
            value={newUserInfo.name || ""}
            onChange={(e) => onAddUserChange("name", e.target.value)}
          />
          <TextField
            style={{ marginTop: "20px", width: "300px" }}
            label="שם משרד"
            value={newUserInfo.office || ""}
            onChange={(e) => onAddUserChange("office", e.target.value)}
          />
          <FormControl style={{ marginTop: "20px", width: "300px" }}>
            <InputLabel>בחר קורסים</InputLabel>
            <Select value={newUserInfo.allowedCourses || []} multiple onChange={(e) => onAddUserChange("allowedCourses", e.target.value)}>
              {props.courses.map((course) => {
                return (
                  <MenuItem key={course._id} value={course._id}>
                    {course.title}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
      </AdminCoursesPopup>
      <div>
        <Button color="primary" variant="contained" onClick={() => setIsPopupOpen(true)}>
          הוסף משתמש חדש
        </Button>
      </div>
      <div className="flex justify-evenly align-flex-end width100 mt-20">
        <div className="width80">
          <Autocomplete
            options={allAllowedUsers}
            onChange={(e, val) => handleSelectedUser(val)}
            getOptionLabel={(option) => option.email + " - " + option.name + " - " + option.office}
            renderOption={(props) => <div>{`${props.email} - ${props.name} - ${props.office}`}</div>}
            renderInput={(params) => <TextField {...params} label="בחר משתמש" />}
          />
        </div>
        <div>
          <Button color="primary" variant="contained" disabled={!selectedUser} onClick={handleAllowedUserUpdate}>
            עדכון
          </Button>
        </div>
      </div>
      {selectedUser && (
        <div className="flex flex-direction-column items-center width100 mt-50">
          <div className="flex justify-evenly width100 mb-50">
            <TextField
              style={{ width: "200px", paddingTop: "10px" }}
              label="שם משתמש"
              value={selectedUser.name || ""}
              onChange={(e) => onSelectedUserChange("name", e.target.value)}
            />
            <TextField
              style={{ width: "200px", paddingTop: "10px" }}
              label="שם משרד"
              value={selectedUser.office || ""}
              onChange={(e) => onSelectedUserChange("office", e.target.value)}
            />
          </div>
          <div className="flex justify-evenly width100 height45">
            <TextField
              style={{ width: "200px", height: "240px", paddingTop: "10px" }}
              label="סיסמת משתמש"
              value={selectedUser.password || ""}
              onChange={(e) => onSelectedUserChange("password", e.target.value)}
            />
            <div className="bg-dark-white width30 padding10 radius10">
              <AdminAutoComplete
                autocompletePlaceholder="רשימת כל הקורסים"
                manageClients
                options={props.courses}
                selectedOptions={selectedCourses}
                onChange={onAllowedCourseChange}
              />
            </div>
          </div>
          <div className="flex flex-direction-column width100 items-center">
            <h5 className="mb-50">שנה את תפוגת הקורס</h5>
            {selectedCourses.map((selectedCourse) => {
              return (
                <div key={selectedCourse.courseId} className="flex justify-between width100 items-center mb-20">
                  <div className="width-45 left">{selectedCourse.title}</div>
                  <div className="width50">
                    <input
                      type="date"
                      style={{ width: "200px" }}
                      label="תאריך תפוגה"
                      value={selectedCourse.expiry.toISOString().substring(0, 10) || ""}
                      onChange={(e) => handleExpiryChange(selectedCourse.courseId, e.target.value)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-20">
            <Button color="secondary" variant="contained" onClick={handleDeleteAllowedUser}>{`למחוק ${selectedUser.email}`}</Button>
          </div>
        </div>
      )}
    </div>
  );

  async function handleAddAllowedUser() {
    try {
      const userInfo = { ...newUserInfo };
      if (userInfo.allowedCourses) {
        const builtAllowedCourseInfo = userInfo.allowedCourses.map((course) => {
          return { courseId: course, expiry: new Date() };
        });
        userInfo.allowedCourses = builtAllowedCourseInfo;
      } else {
        userInfo.allowedCourses = [];
      }
      const res = await adminService.addAllowedUser(userInfo);
      if (res.success) {
        userInfo._id = res.user.id;
        Swal.fire("משתמש עודכן בהצלחה", "", "success");
        allAllowedUsers.push(userInfo);
        handleClosePopup();
      } else {
        Swal.fire("לא ניתן להוסיף משתמש", "", "error");
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function handleAllowedUserUpdate() {
    try {
      const selectedCoursesCopy = [...selectedCourses];
      selectedCoursesCopy.forEach((course) => delete course.title);
      const updates = { ...selectedUser };
      updates.allowedCourses = selectedCoursesCopy;
      const res = await adminService.updateAllowedUser(updates);
      if (res.success) {
        Swal.fire("משתמש עודכן בהצלחה", "", "success");
        const getAllUsers = [...allAllowedUsers];
        updates.allowedCourses.map((allowedCourse) => {
          return (allowedCourse.title = props.courses.find((course) => course._id === allowedCourse.courseId).title);
        });
        getAllUsers[getAllUsers.findIndex((user) => user._id === selectedUser._id)] = updates;
        setAllAllowedUsers(getAllUsers);
      } else {
        Swal.fire("לא ניתן היה לעדכן את המשתמש", "", "error");
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function handleDeleteAllowedUser() {
    try {
      Swal.fire({
        title: "האם אתה בטוח שברצונך למחוק את המשתמש?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "כן",
        cancelButtonText: "לא",
        closeOnConfirm: false,
        closeOnCancel: false
      }).then(async (result) => {
        if (result.value === true) {
          const res = await adminService.deleteAllowedUser(selectedUser._id);
          if (res.success) {
            Swal.fire("המשתמש נמחק בהצלחה", "", "success");
            const getAllUsers = [...allAllowedUsers];
            getAllUsers.splice(
              getAllUsers.findIndex((user) => user._id === selectedUser._id),
              1
            );
            setAllAllowedUsers(getAllUsers);
            setSelectedUser(null);
          } else {
            Swal.fire("לא ניתן היה למחוק את המשתמש", "", "error");
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  function handleSelectedUser(val) {
    setSelectedUser(val);
    if (val === null) return;
    const allowedCourses = val.allowedCourses.map((allowedCourse) => {
      let selectedCourse = props.courses.find((course) => course._id === allowedCourse.courseId);
      const allowedUserCourse = {};
      allowedUserCourse.courseId = allowedCourse.courseId;
      allowedUserCourse.title = selectedCourse.title;
      allowedUserCourse.expiry = new Date(allowedCourse.expiry);
      return allowedUserCourse;
    });
    setSelectedCourses(allowedCourses);
  }

  function onAllowedCourseChange(newList) {
    setSelectedCourses(newList);
  }

  function onSelectedUserChange(type, value) {
    const oldData = { ...selectedUser };
    oldData[type] = value;
    setSelectedUser(oldData);
  }

  function onAddUserChange(type, value) {
    const oldData = { ...newUserInfo };
    oldData[type] = value;
    setNewUserInfo(oldData);
  }

  function handleExpiryChange(id, value) {
    const newSelectedCourses = [...selectedCourses];
    newSelectedCourses.find((course) => course.courseId === id).expiry = new Date(value);
    setSelectedCourses(newSelectedCourses);
  }

  function handleClosePopup() {
    setIsPopupOpen(false);
    setNewUserInfo({});
  }
};

export default AdminAssignAllowedCourses;
